module.exports = __webpack_public_path__ + "img/nogoburn-min.355b39a0.jpg";